import { env } from '@/common/host.js'

export function concatUrl (url) {
  // if (process.env.NODE_ENV !== 'production') {
  //   require('../config')
  // }
  const baseUrl = env.baseUrl
  let bul = baseUrl
  if (baseUrl.endsWith('/')) {
    bul = bul.substring(0, bul.length - 1)
  }
  if (url.startsWith('/')) {
    return bul + url
  } else {
    return bul + '/' + url
  }
}
export function getWebTracingUrl() {
  const webTracingUrl = env.webTracingUrl;
  const appCode = env.webTracingAppCode;
  // if (process.env.NODE_ENV !== 'production') {
  //   require('../config')
  //   webTracingUrl = env.webTracingUrl
  //   appCode = env.webTracingAppCode
  // } else {
  //   webTracingUrl = env.webTracingUrl
  //   appCode = env.webTracingAppCode
  // }
  return {webTracingUrl, appCode}
}

/**
 * todo  获取WpsApiUrl 服务地址
 * @returns {*}
 */
export const getWpsApiUrl = ()=>{
  if (process.env.NODE_ENV !== 'production') {
    require('../config')
  }
  return window.wpsUrl
}
